import React from 'react';
import ParallaxLayer from './ParallaxLayer';
import FloatingParticles from './FloatingParticles';
import useTypewriter from '../hooks/useTypewriter';
import './Hero.css';

const Hero = () => {
  // Typewriter effect for the main title
  const { displayText, isTyping, isComplete } = useTypewriter(
    'Gabrielle Grace Martinez',
    60, // Speed: 60ms per character (half second slower)
    500, // Delay: 500ms after fade-in starts
    false, // No loop
    0 // No pause time
  );

  return (
    <section className="hero">
      {/* Enhanced Parallax Background Layers */}
      <div className="parallax-container">
        <ParallaxLayer type="base" scrollSpeed={0.2} />
        <ParallaxLayer type="shapes" scrollSpeed={0.4} />
        <ParallaxLayer type="patterns" scrollSpeed={0.6} />
        <ParallaxLayer type="details" scrollSpeed={0.8} />
        <ParallaxLayer type="particles" scrollSpeed={1.0} />
        <ParallaxLayer type="interactive" scrollSpeed={1.2} />
        <FloatingParticles
          particleCount={4}
          particleType="mixed"
          colorScheme="warm"
          intensity={0.3}
        />
      </div>
      
      <div className="hero-container">
        <div className="hero-content">
          <h1 className="hero-title">
            <div className="typewriter-container">
              <span className="typewriter-text">{displayText}</span>
              {!isComplete && (
                <span 
                  className={`typewriter-cursor ${isTyping ? 'typing' : ''}`}
                ></span>
              )}
            </div>
          </h1>
          <p className="hero-subtitle">
            Aspiring Legal Professional
          </p>
          <p className="hero-description">
            University of Michigan Political Science graduate with extensive experience in legal assistance, 
            community outreach, and leadership. Passionate about advocating for immigrant rights and 
            pursuing a career in law to make a meaningful impact in the legal field.
          </p>
          <div className="hero-details">
            <div className="detail-item">
              <span className="detail-label">Education:</span>
              <span className="detail-value">University of Michigan, Political Science</span>
            </div>
            <div className="detail-item">
              <span className="detail-label">Current Role:</span>
              <span className="detail-value">Legal Assistant at Weis, DuBrock, Doody, & Maher</span>
            </div>
            <div className="detail-item">
              <span className="detail-label">Languages:</span>
              <span className="detail-value">English, Conversational Spanish</span>
            </div>
          </div>
          <div className="hero-cta">
            <button 
              className="cta-button"
              onClick={() => document.getElementById('work').scrollIntoView({ behavior: 'smooth' })}
            >
              Explore My Experience
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
